module.exports = __webpack_public_path__ + "img/logo-error.9ea39828.png";